import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Vehicle2Icon } from "@/shared/icons";

type Props = {
  count: number;
  onClick: () => void;
};

export default function VehicleOfferUpgradeButton({ count, onClick }: Props) {
  const { t } = useTranslation("offer");
  return (
    <button
      className={clsx(
        "flex justify-between items-center h-11.5 mb-5 py-3 pl-4 pr-3 text-12 font-bold uppercase bg-gradient-to-r from-[#1C1C1C] to-dark-800 rounded-xl hover:brightness-110",
        !count && "pointer-events-none",
      )}
      type="button"
      onClick={onClick}
    >
      <div className="flex items-center gap-2.5">
        <Vehicle2Icon className="w-4.5" />
        <p>{t("offer.vehicle.details")}</p>
      </div>
      {count && (
        <p className="flex justify-center items-center h-5.5 py-[0.44rem] px-1.5 bg-white/5 rounded-md">
          {count}
        </p>
      )}
    </button>
  );
}
